const offerTypes = {
	OPEN: "open",
	WORK_ORDER: "direct",
	INQUIRY: "inquiry",
};

export default offerTypes;
